/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Overview } from '../../models/overview';

export interface GetModalitySystemOverview$Params {
  modalityId: number;
  systemSerialNumber?: string;
  systemMaterialNumber?: number;
}

export function getModalitySystemOverview(http: HttpClient, rootUrl: string, params: GetModalitySystemOverview$Params, context?: HttpContext): Observable<StrictHttpResponse<Overview>> {
  const rb = new RequestBuilder(rootUrl, getModalitySystemOverview.PATH, 'get');
  if (params) {
    rb.path('modalityId', params.modalityId, {});
    rb.query('systemSerialNumber', params.systemSerialNumber, {});
    rb.query('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Overview>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getModalitySystemOverview.PATH = '/api/applications/{modalityId}';
getModalitySystemOverview.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getModalitySystemOverview.ROOTURL = '/portal';
